import "./MainSectionDescription.css";

function MainSectionDescription() {
  return (
    <>
      <section className="Description">
        <div className="descriptionContenitor">
          <div className="videoSea videoplayer">
            <video
              width="380"
              controls
              playsInline
              preload="auto"
              muted
              autoPlay
              title="Video tour of Positano coast"
              aria-label="Video showing the Amalfi Coast from the boat"
              aria-describedby="video-caption"
            >
              <source src="../Assets/positano2.0.mp4" type="video/mp4" />
              <p>
                Your browser does not support the video tag. You can{' '}
                <a href="../Assets/positano2.0.mp4" download>download the video here</a>.
              </p>
            </video>
          </div>

          <div className="motto" id="video-caption">
            <p>
              "Sailing is like living in another world: a world of peace,
              tranquility and beauty. The sea is not just a place to go, but a
              way of being."
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default MainSectionDescription;
